import { getMediaDetail } from '@apis/media';
import DataHookFactory from '@templates/DataHookFactory';
import { IMedia } from 'interface/medias';

const useMediaDetail = DataHookFactory<IMedia>(
  async (id: string) => {
    const resp = await getMediaDetail(id);
    if (resp.status !== 200) throw new Error('Get media list failed');
    return resp.data;
  },
  {
    autoFetch: true,
    minimumInterval: 5000,
  },
);

export default useMediaDetail;
